import { DragEvent, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import descriptionSVG from "src/assets/description.svg";
import download from "src/assets/download-cloud.svg";
import uploadSvg from "src/assets/upload.svg";
import { poActions } from "src/context/po-slice";
import GenericForm from "src/pages/counter-master/form.component";
import * as yup from "yup";
import Modal from "src/components/hoc/modal.component"
import { unparse } from "papaparse";
import { orderTypeExpBulkUploadActions } from "src/context/order-type-exp-bulk-upload-slice";
import { RootState } from "src/context/store";
import { toast } from "src/hooks/useToast";
import { bulkUploadCounter, getFormatFileCounter } from "src/services/bulk-upload-api";
import { getAllCompanyDetails } from "src/services/company-api";
import ErrorInFile from "src/components/employee-bulk-upload/error-file";
import SuccessDialog from "src/components/employee-bulk-upload/success-dialog";
import UploadingProgress from "src/components/employee-bulk-upload/uploading-progress";
import { Button } from "src/components";
import { Spinner } from "src/components";
import { validateOrderTypeExpBulkFile } from "./validateOrderTypeExpBulkFile";

const Divider = () => <div className="h-[0.0625rem] w-full bg-[#00000010] mx-auto" />;

const OrderBulkUpload = () => {
  const [modalOpen, setModalOpen] = useState("modal-open-1");
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [progress, setProgress] = useState(0);
  const [errorInFile, setErrorInFile] = useState(false);
  const file = useSelector((state: RootState) => state.orderTypeExpBulkUpload.file);
  const selectedData = useSelector((state: RootState) => state.orderTypeExpBulkUpload.selectedData);
  const companyList = useSelector((state: RootState) => state.orderTypeExpBulkUpload.companyList);
  const url = useRef<string>("");
  const noOfErrors = useRef<number>(0);
  const dispatch = useDispatch();
  const [validResults, setValidResults] = useState<any[]>([]);

  const typeList = [
    { name: "Add Order Type Exception", select_type: "bulkOrderTypeException" },  //M10-11561
  ];

  const Download = async () => {
    let url: any = "";
    try {
      url = await getFormatFileCounter();
    } catch (e) {
      console.error(e);
    }

    const link = document.createElement("a");
    link.href = url.data;
    link.download = "Bulk_Upload_format_counter.zip";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    getAllCompanyDetails()
      .then((res) => {
        dispatch(orderTypeExpBulkUploadActions.setCompanyList(res?.data));
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function onDropHandler(e: DragEvent<HTMLDivElement>) {
    e.preventDefault();
    if (e.dataTransfer.files.length > 0) {
      onChangeHandeler(e.dataTransfer.files);
    }
  }

  const fileUpload = (file: FileList | null) => {
    if (file && validResults.length > 0) {
      setModalOpen("modal-open-5");
      //M10-11561
      const normalizedResults = validResults.map((row: any) => {
        const newRow: any = { ...row };
        Object.keys(newRow).forEach((key) => {
          if (typeof newRow[key] === "object" && newRow[key] !== null) {
            newRow[key] = JSON.stringify(newRow[key]);
          }
        });
        return newRow;
      });

      const fileAsString = unparse(normalizedResults, { delimiter: ",", newline: "\r\n" });
      //M10-11561
      const blob = new Blob([fileAsString], { type: "text/csv;charset=utf-8;" });
      let fileName = file[0].name.slice(0, -4);
      fileName = fileName.replace(/[\s~`!@#$%^&*(){}\[\];:"'<,.>?\/\\|_+=-]/g, "");
      fileName = fileName + ".csv";
      console.log(fileName);

      const formData = new FormData();
      formData.append("file", blob, fileName);
      formData.append("company_short_name", selectedData?.code.shortname);
      formData.append("functionality", selectedData.select_type.select_type);
      bulkUploadCounter(formData, {
        onUploadProgress: (progressEvent: any) => {
          const progress = Math.round((progressEvent.loaded / progressEvent.total!) * 100);
          setProgress(progress);
        },
      })
        .then((res) => {
          toast({ description: "File uploaded successfully" });
          console.log(res);
          setSuccessDialogOpen(true);
          setProgress(0);
          return;
        })
        .catch((err) => {
          console.error(err);
          toast({ description: "Something went wrong", variant: "destructive" });
        });
    } else {
      console.error("Please select a file ");
      toast({ description: "Please select a file with a valid format", variant: "destructive" });
    }
  };

  const onChangeHandeler = async (e: FileList) => {
    setModalOpen("modal-open-3");
    dispatch(orderTypeExpBulkUploadActions.setUploadedFile(e));
    validateOrderTypeExpBulkFile(e || new FileList(), selectedData)
      .then(
        //res.length > 0 ? setModalOpen("modal-open-4") : setModalOpen("modal-open-3");
        (res: any) => {
          setValidResults(res);
          setModalOpen("modal-open-4");
          setErrorInFile(false);
        }
      )
      .catch((error: any) => {
        console.log(error, "error");
        const csv = unparse(error as []);
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
        const temp = URL.createObjectURL(blob);
        noOfErrors.current = (error as []).length;
        url.current = temp;
        setErrorInFile(true);
        setModalOpen("modal-open-2");
      });

  };

  const schema = yup.object().shape({
    code: yup.object().required("Company is required"),
    select_type: yup.object().required("Functionality is required"),
  });

  const formFields = [
    {
      label: "Select Company",
      type: "autocomplete",
      keyofForm: "code",
      suggestionList: companyList || [],
      displayKey: "name",
      size: "full",
    },
    {
      label: "Select Type",
      type: "autocomplete",
      keyofForm: "select_type",
      suggestionList: typeList || [],
      displayKey: "name",
      size: "full",
    },
  ];

  const autoCompleteChangeHandler = (value: any, keyofForm: any) => {
    if (keyofForm) {
      dispatch(orderTypeExpBulkUploadActions.setSelectedData({ key: keyofForm, value: value }));
    }
  };

  return (
    <>
      {
        //Section 1 : Select company and type functionality
      }
      <Modal
        isHeader={true}
        isOpen={modalOpen == "modal-open-1"}
        onCloseModal={() => {
          dispatch(poActions.setBulkUploadModalState({ key: "orderTypeExcBulk", value: false }));
          dispatch(orderTypeExpBulkUploadActions.reset());
        }}
        title="Order Type Exception Bulk Upload"
      >
        <div className="w-[90vw] sm:w-[60vw] md:w-[40vw]">
          <GenericForm
            formFields={formFields}
            onFormSubmit={() => {
              setModalOpen("modal-open-2");
              // console.log(formFields);
            }}
            schema={schema}
            isControlled={true}
            defaultValues={selectedData}
            onAutocompleteChange={autoCompleteChangeHandler}
          >
            {" "}
            <Divider />
            <footer className="flex justify-end gap-2 px-5 py-3">
              <Button
                className="border hover:bg-[#33C481]"
                onClick={() => {
                  Download();
                }}
              >
                <img src={download} alt="icon" width={16} height={16} className="mr-2 " />
                Format File
              </Button>
              <Button
                className="border"
                onClick={() => {
                  dispatch(poActions.setBulkUploadModalState({ key: "orderTypeExcBulk", value: false }));
                }}
              >
                Back
              </Button>
              <Button type="submit" className={`bg-[#7F56D9]  text-white `}>
                Go to Upload
              </Button>{" "}
            </footer>
          </GenericForm>
        </div>
      </Modal>
      {
        //Section 2 : Upload file screen
      }
      <Modal
        isHeader={true}
        isOpen={modalOpen == "modal-open-2"}
        onCloseModal={() => {
          dispatch(poActions.setBulkUploadModalState({ key: "orderTypeExcBulk", value: false }));
        }}
        onBack={() => {
          setModalOpen("modal-open-1");
        }}
        title="Order Type Exception Bulk Upload"
      >
        <div className="w-[90vw] sm:w-[60vw] md:w-[40vw]">
          <div className="flex flex-col gap-4 px-5 pt-2 pb-4">
            <label
              htmlFor="fileInput"
              className="w-full h-40 pl-[26px] pr-[25px] py-7 bg-white rounded-xl border border-neutral-400 justify-center items-center inline-flex"
            >
              <div
                className="inline-flex flex-col items-center self-stretch justify-start gap-5"
                onDrop={(e) => {
                  onDropHandler(e);
                }}
                onDragOver={(event) => event.preventDefault()}
              >
                <div className="relative w-10 h-10">
                  <img src={uploadSvg} alt="upload" className="absolute top-0 left-0 w-10 h-10" />
                </div>
                <div className="flex flex-col items-center justify-start gap-3">
                  <div className="inline-flex items-start justify-start gap-1">
                    <div className="text-zinc-900 text-base font-medium font-['Inter'] leading-none">Drag & drop files</div>
                    <div className="text-zinc-900 text-base font-medium font-['Inter'] leading-none">or</div>
                    <div className="text-indigo-500 text-base font-semibold font-['Inter'] underline leading-none">Browse</div>
                  </div>
                  <div className="text-neutral-400 text-[13px] font-normal font-['Inter'] leading-none hover:text-red-500">
                    Only .csv file formats are supported.
                  </div>
                </div>
              </div>
              <input
                id="fileInput"
                onChange={(e) => {
                  onChangeHandeler(e.target.files!);
                  // setModalOpen("modal-open-3");
                  console.log("File changed");
                }}
                type="file"
                accept=".csv"
                hidden
              />
            </label>
            {errorInFile && <ErrorInFile errors={noOfErrors.current} url={url.current} />}
          </div>
          <footer className="flex justify-end gap-2 px-5 py-3">
            <Button
              className="border"
              onClick={() => {
                setModalOpen("modal-open-1");
              }}
            >
              Back
            </Button>
            <Button type="submit" className={`bg-[#7F56D9]  text-white `} disabled={true}>
              Validate File
            </Button>{" "}
          </footer>
        </div>
      </Modal>
      {
        //Section 3 : Validating File
      }
      <Modal
        isHeader={true}
        isOpen={modalOpen == "modal-open-3"}
        onCloseModal={() => {
          dispatch(poActions.setBulkUploadModalState({ key: "orderTypeExcBulk", value: false }));
        }}
        onBack={() => {
          setModalOpen("modal-open-2");
        }}
        title="Order Type Exception Bulk Upload"
      >
        <div className="w-[90vw] sm:w-[60vw] md:w-[40vw]">
          <div className="w-[90vw] sm:w-[60vw] md:w-[40vw]  p-4 flex flex-col justify-center items-center">
            <Spinner />
            <div className="text-center text-[14px] mt-4 font-medium text-neutral-900">Validating...</div>
          </div>
          <footer className="flex justify-end gap-2 px-5 py-3">
            <Button
              className="border"
              onClick={() => {
                setModalOpen("modal-open-2");
              }}
            >
              Cancel
            </Button>
            <Button type="submit" className={`bg-[#7F56D9]  text-white `} disabled={true}>
              Validating...
            </Button>{" "}
          </footer>
        </div>
      </Modal>
      {
        //Section 4 : Upload File
      }
      <Modal
        isHeader={true}
        isOpen={modalOpen == "modal-open-4"}
        onCloseModal={() => {
          dispatch(poActions.setBulkUploadModalState({ key: "orderTypeExcBulk", value: false }));
        }}
        onBack={() => {
          setModalOpen("modal-open-2");
        }}
        title="Order Type Exception Bulk Upload"
      >
        <div className="w-[90vw]  sm:w-[60vw] md:w-[40vw]">
          <div className="flex items-center justify-start h-20 gap-4 px-5 pt-2 pb-4">
            <img className="w-10 h-10" alt="Description" src={descriptionSVG} />
            <div className="flex flex-col">
              <div className="text-sm font-semibold text-gray-900">{(file && file[0]?.name) || "File Name"}</div>
              <div className="text-xs font-medium text-gray-300">{(file && file[0]?.size) || "0"} bytes</div>
            </div>
          </div>

          <footer className="flex justify-end gap-2 px-5 py-3">
            <Button
              className="border"
              onClick={() => {
                setModalOpen("modal-open-2");
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className={`bg-[#7F56D9]  text-white `}
              onClick={() => {
                fileUpload(file ? file : null);
              }}
            >
              Upload
            </Button>{" "}
          </footer>
        </div>
      </Modal>
      {
        //Section 5 : Uploading File
      }

      <Modal
        isHeader={true}
        isOpen={modalOpen == "modal-open-5"}
        onCloseModal={() => {
          dispatch(poActions.setBulkUploadModalState({ key: "orderTypeExcBulk", value: false }));
        }}
        onBack={() => {
          setModalOpen("modal-open-2");
        }}
        title="Order Type Exception Bulk Upload"
      >
        <div className="p-5">
          <UploadingProgress progress={progress} fileName={file ? file[0].name : "fileName"} />
        </div>

        <footer className="flex justify-end gap-2 px-5 py-3">
          <Button
            className="border"
            onClick={() => {
              setModalOpen("modal-open-2");
            }}
          >
            cancel
          </Button>
          <Button type="submit" className={`bg-[#7F56D9]  text-white `} disabled={true}>
            Uploading...
          </Button>{" "}
        </footer>
      </Modal>
      {
        //Section 6 : Done
      }
      {
        <SuccessDialog
          open={successDialogOpen}
          onClose={() => {
            setSuccessDialogOpen(false);
            setModalOpen("modal-open-1");
            dispatch(orderTypeExpBulkUploadActions.reset());
            dispatch(poActions.setBulkUploadModalState({ key: "orderTypeExcBulk", value: false }));
          }}
        />
      }
    </>
  );
};

export default OrderBulkUpload;
